exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-w-full[data-v-bc3e7706]{width:auto}.recipient label[data-v-bc3e7706],.sender label[data-v-bc3e7706]{display:none}", ""]);

// exports
